import { checkboxColumnId } from '../../Table.helpers';
import { checkboxSpacing } from '../../Table.styles';

export const checkboxColumnDefinition = {
    id: checkboxColumnId,
    spacing: checkboxSpacing,
    headerTextAlign: 'center' as const,
};
